import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {HomePresenter} from "./homePresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class HomeView extends ViewBase implements IView {

    public _presenter: HomePresenter;
    
    public set displayName(displayName){
        this.setTextById('display-name', displayName);
    }

    public set email(email){
        this.setTextById('email', email);
    }
    
    
    
    public set handle(handle){
        this.setTextById('handle-name', handle);
    }
    
    public set connectionCode(connectionCode){
        this.setTextById('connection-code',connectionCode);
    }


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: HomePresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    public setPresenter(presenter: HomePresenter) {
        this._presenter = presenter;
    }

    public render(): void {
    }


}